import { ViewPositionNullIcon } from '@/client/assets';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

export const PositionNothing = memo(() => {
  const { t } = useTranslation();
  return (
    <div className="w-full p-4 space-y-3 text-center">
      <ViewPositionNullIcon className="size-16.5 mx-auto fill-foreground/10" />
      <span className="text-foreground/70 font-normal text-sm text-center">{t('nothing-yet')}</span>
    </div>
  );
});
PositionNothing.displayName = 'PositionNothing';
